import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Briefcase, Calculator, FileBadge, ShieldCheck, Building2, Users, FileText, Scale, Landmark, Heart, Fingerprint, Globe, Award, Store, HandCoins, FileCheck, Receipt, ClipboardCheck, UserCheck, Building } from 'lucide-react';

const iconMap = {
  Briefcase, Calculator, FileBadge, ShieldCheck, Building2, Users, FileText, Scale, 
  Landmark, Heart, Fingerprint, Globe, Award, Store, HandCoins, FileCheck, 
  Receipt, ClipboardCheck, UserCheck, Building
};

const ServiceCard = ({ service, linkTo }) => {
  const IconComponent = iconMap[service.icon] || Briefcase;

  return (
    <div 
      className="group relative overflow-hidden bg-white border border-slate-200 hover:border-primary/50 transition-all duration-300 hover:shadow-xl cursor-pointer"
      data-testid={`service-card-${service.id}`}
    >
      <Link to={linkTo || '/contact'} className="block h-full">
        {/* Image */}
        {service.image && (
          <div className="relative h-40 overflow-hidden">
            <img 
              src={service.image} 
              alt={service.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            <div className="absolute bottom-3 left-3">
              <div className="w-10 h-10 bg-white/90 rounded-lg flex items-center justify-center">
                <IconComponent className="w-5 h-5 text-primary" />
              </div>
            </div>
          </div>
        )}

        {/* Content */}
        <div className="p-6">
          {/* Title */}
          <h3 className="font-heading text-xl font-semibold text-slate-800 mb-3 group-hover:text-primary transition-colors">
            {service.title}
          </h3>

          {/* Description */}
          <p className="font-body text-sm text-slate-600 leading-relaxed mb-4">
            {service.description}
          </p>

          {/* Features */}
          {service.features && (
            <div className="flex flex-wrap gap-2 mb-4">
              {service.features.slice(0, 3).map((feature, index) => (
                <span 
                  key={index}
                  className="font-body text-xs bg-slate-100 text-slate-600 px-2 py-1 rounded"
                >
                  {feature}
                </span>
              ))}
            </div>
          )}

          {/* CTA */}
          <div className="flex items-center justify-end pt-4 border-t border-slate-100">
            <span className="flex items-center gap-1 font-body text-sm font-medium text-primary group-hover:gap-2 transition-all">
              Learn More
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ServiceCard;
